/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_ProductsInputs */

const vi_shop_home_link_products = /** @type {(inputs: Shop_Home_Link_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách SP theo danh mục`)
};

/**

* @param {Shop_Home_Link_ProductsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_products = /** @type {((inputs?: Shop_Home_Link_ProductsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_ProductsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_products(inputs)
});